/**
 * Array of all valid redemption include relations
 * Used for runtime validation
 */
export const VALID_REDEMPTION_RELATIONS = [
    'redeemCount',
    'ownerBusiness',
    'requiredUserInfo',
    'booking'
];
/**
 * Type guard to validate redemption include relation at runtime
 *
 * @param value - String to validate
 * @returns True if value is a valid RedemptionIncludeRelation
 */
export function isValidRedemptionRelation(value) {
    return VALID_REDEMPTION_RELATIONS.includes(value);
}
//# sourceMappingURL=redemption-include-relation.type.js.map